import { useState } from 'react';
import DataTable from '../../components/DataTable';

// Örnek oda tipleri — gerçekte backend'den gelir
const SISTEM_ODA_TIPLERI = ['Seçiniz', 'Standart', '2 KİŞİ', '3 KİŞİ', 'ÇİFT + 2 TEK', 'Deluxe', 'Suite', 'Superior'];

const KANAL_ODALAR = [
  { id: 1, kyAd: 'Standard Room' },
  { id: 2, kyAd: 'Deluxe Room' },
  { id: 3, kyAd: 'Suite Room' },
];

export default function KanalAyarlar() {
  const [otomatikGonder, setOtomatikGonder] = useState(true);
  const [eslestirmeler, setEslestirmeler] = useState(
    KANAL_ODALAR.reduce(function(acc, oda) {
      acc[oda.id] = 'Standart';
      return acc;
    }, {})
  );
  const [kaydetMesaj, setKaydetMesaj] = useState('');

  function handleEslestir(odaId, deger) {
    setEslestirmeler(function(prev) {
      return Object.assign({}, prev, { [odaId]: deger });
    });
  }

  function kaydet() {
    setKaydetMesaj('Ayarlar kaydedildi.');
    setTimeout(function() { setKaydetMesaj(''); }, 3000);
  }

  return (
    <div className="p-6 max-w-3xl space-y-6">
      <h1 className="text-lg font-bold text-gray-800">Kanal yöneticisi ayarlar</h1>

      {/* Otomatik gönder */}
      <div className="bg-white rounded-xl border border-gray-200 shadow-sm px-5 py-4">
        <label className="flex items-center gap-3 cursor-pointer select-none">
          <input
            type="checkbox"
            checked={otomatikGonder}
            onChange={function(e) { setOtomatikGonder(e.target.checked); }}
            className="w-4 h-4 accent-blue-600 cursor-pointer"
          />
          <span className="text-sm text-gray-700">Oda müsaitliğini reselivaya otomatik gönder</span>
        </label>
      </div>

      {/* Oda tipi eşleştirme */}
      <div className="bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden">
        <div className="px-5 py-4 border-b border-gray-100">
          <h2 className="text-sm font-bold text-gray-700">Oda tipi eşleştirme</h2>
          <p className="text-xs text-gray-400 mt-0.5">
            Kanal yöneticisindeki oda tiplerini sisteminizdeki oda tipleriyle eşleştirin.
          </p>
        </div>
        <DataTable
          anahtarAlan="id"
          satirlar={KANAL_ODALAR}
          bosMetin="Eşleştirilecek oda tipi yok"
          kolonlar={[
            {
              anahtar: 'kyAd', baslik: 'KY Oda Tipi Adı',
              ciz: oda => <span className="text-gray-700">{oda.kyAd}</span>,
            },
            {
              anahtar: 'eslesme', baslik: 'Sistem Oda Tipi Adı',
              ciz: oda => (
                <div className="relative inline-block w-52">
                  <select
                    value={eslestirmeler[oda.id] || 'Seçiniz'}
                    onChange={function(e) { handleEslestir(oda.id, e.target.value); }}
                    className="w-full border-2 border-gray-100 rounded-2xl px-3 py-2 pr-8 text-sm bg-white text-gray-700 focus:outline-none focus:border-violet-400 appearance-none cursor-pointer">
                    {SISTEM_ODA_TIPLERI.map(function(tip) {
                      return <option key={tip} value={tip}>{tip}</option>;
                    })}
                  </select>
                  <span className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 text-xs">▼</span>
                </div>
              ),
            },
          ]}
        />
      </div>

      {/* Kaydet butonu */}
      <div className="flex items-center gap-4">
        <button
          onClick={kaydet}
          className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-2.5 rounded-lg text-sm font-bold transition-colors">
          Kaydet
        </button>
        {kaydetMesaj && (
          <span className="text-green-600 text-sm font-medium">✓ {kaydetMesaj}</span>
        )}
      </div>
    </div>
  );
}